// extracted by mini-css-extract-plugin
export default {"dropdownItem":"TaxDeclarationScreen_dropdownItem__oVlN1"};